import {useEffect, useState} from "react";
import * as lscache from "lscache";

import {OFFER_CHATBOT_STORAGE_KEY} from "../../app/constants/storage_keys";
export const useOfferChatbotStorage = () => {
    const [isOfferChatBotAvailable, setIsOfferChatBotAvailable] = useState(true);

    useEffect(() => {
        const offerChatBotStorage = lscache.get(OFFER_CHATBOT_STORAGE_KEY);

        if (offerChatBotStorage && offerChatBotStorage.hasBeenSent) {
            setIsOfferChatBotAvailable(false);
        }
    }, []);

    const syncStorageOnFormSubmit = () => {
        lscache.set(OFFER_CHATBOT_STORAGE_KEY, {hasBeenSent: true});
    };

    return {
        isOfferChatBotAvailable,
        setIsOfferChatBotAvailable,
        syncStorageOnFormSubmit
    };
};
import {useEffect, useState} from "react";
import * as lscache from "lscache";

import {OFFER_CHATBOT_STORAGE_KEY} from "../../app/constants/storage_keys";
export const useOfferChatbotStorage = () => {
    const [isOfferChatBotAvailable, setIsOfferChatBotAvailable] = useState(true);

    useEffect(() => {
        const offerChatBotStorage = lscache.get(OFFER_CHATBOT_STORAGE_KEY);

        if (offerChatBotStorage && offerChatBotStorage.hasBeenSent) {
            setIsOfferChatBotAvailable(false);
        }
    }, []);

    const syncStorageOnFormSubmit = () => {
        lscache.set(OFFER_CHATBOT_STORAGE_KEY, {hasBeenSent: true});
    };

    return {
        isOfferChatBotAvailable,
        setIsOfferChatBotAvailable,
        syncStorageOnFormSubmit
    };
};
